/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Edit_Hide_ValueInputs */

const en_forms_rule_sets_edit_hide_value = /** @type {(inputs: Forms_Rule_Sets_Edit_Hide_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Value`)
};

const de_forms_rule_sets_edit_hide_value = /** @type {(inputs: Forms_Rule_Sets_Edit_Hide_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide Value" |
*
* @param {Forms_Rule_Sets_Edit_Hide_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_edit_hide_value = /** @type {((inputs?: Forms_Rule_Sets_Edit_Hide_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Edit_Hide_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_edit_hide_value(inputs)
	return de_forms_rule_sets_edit_hide_value(inputs)
});